__webpack_require__.p = "https://axiomuatprice.icelanddev.net/";